import React from 'react';
import FaQuestion from 'react-icons/lib/fa/question-circle-o';
import { teacherInProductHelpLinks } from '../../constants/helpLinks';
import { withTranslation } from 'react-i18next';
import { GetBrandedSupportURL } from '../../services/BrandingService';

class HelpButton extends React.Component {
  render() {
    const currentPath = window.location.pathname
    let help = teacherInProductHelpLinks.find(x => currentPath.startsWith(x.pathname));
    const supportURL = GetBrandedSupportURL();
    if (supportURL) {
      // if a partner wants to use a different help URL than override the current link
      help = { link: supportURL };
    }
    const helpButtonStyle = {}
    if (!help) helpButtonStyle.visibility = 'hidden';
    return (
      <div className="helpButton" style={helpButtonStyle}>
        <a className="helpButtonLink" href={help ? help.link: ""} target="_blank">
          <FaQuestion className="helpButtonIcon" size="22" />
          {this.props.t("help")}
        </a>
      </div>
    );
  }
}

export default withTranslation('reports')(HelpButton);